import reducer from "./reducers";

import * as consulationActions from "./actions";

export { consulationActions };

export default reducer;
